import createIcon from '../../createIcon';

/**
 * @component @name Filter9
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1SDFWMjFDMSAyMi4xIDEuOSAyMyAzIDIzSDE5VjIxSDNWNVpNMjEgMUg3QzUuOSAxIDUgMS45IDUgM1YxN0M1IDE4LjEgNS45IDE5IDcgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjNDMjMgMS45IDIyLjEgMSAyMSAxWk0yMSAxN0g3VjNIMjFWMTdaTTE1IDVIMTNDMTEuOSA1IDExIDUuODkgMTEgN1Y5QzExIDEwLjExIDExLjkgMTEgMTMgMTFIMTVWMTNIMTFWMTVIMTVDMTYuMSAxNSAxNyAxNC4xMSAxNyAxM1Y3QzE3IDUuODkgMTYuMSA1IDE1IDVaTTE1IDlIMTNWN0gxNVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Filter9 = createIcon('Filter9', [
  [
    'path',
    {
      d: 'M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM15 5H13C11.9 5 11 5.89 11 7V9C11 10.11 11.9 11 13 11H15V13H11V15H15C16.1 15 17 14.11 17 13V7C17 5.89 16.1 5 15 5ZM15 9H13V7H15V9Z',
      key: '1djfwc',
    },
  ],
]);

export default Filter9;
